<template>
  <div class="creative-landingpage">
    <ColumnBlock :title="title" :configable="false" :clearable="false">
      <div class="landing-page-wrapper">
        <el-table class="common-el-table-styles" :data="tableData" border style="width: 100%">
          <el-table-column prop="accountName" show-overflow-tooltip label="账号" width="90"> </el-table-column>
          <el-table-column label="品牌形象">
            <template slot-scope="{ row }">
              <el-button type="text" @click="onProfileSelect(row)" :title="row.profile.text">{{ row.profile.text }}</el-button>
            </template>
          </el-table-column>
          <el-table-column label="落地页" width="90">
            <template slot-scope="{ row }">
              <el-button type="text" @click="onLandingPageSelect(row)">{{ row.landingPages.text }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </ColumnBlock>

    <AdProfile
      :visible.sync="showGlobalProfileModify"
      :current-row="currentModifyTableRow"
      @confirm="onProfileModifyConfirm"
      @cancel="onModifyModalCancel"
    ></AdProfile>

    <AdPagesV3ModifyModal
      title="落地页跳转"
      :visible.sync="showGlobalPagesModify"
      :current-row="currentModifyTableRow"
      @confirm="onPageModifyConfirm"
      @cancel="onModifyModalCancel"
    ></AdPagesV3ModifyModal>
  </div>
</template>

<script setup>
import { toRefs, computed, inject, nextTick } from 'vue'
import eventBus from '@/event-bus.js'

import ColumnBlock from '@/views/create/bytedance/components/layout/block.vue'
import AdProfile from '@/views/create/gdt/components/distribute/components/ad-profile.vue'
import AdPagesV3ModifyModal from '@/views/create/gdt/components/distribute/components/ad-langingpage-v3.vue'
import { useTable, useProfile, useLandingPages } from './hooks/useLandingPages.js'

const { opId } = inject('localStates')
// eslint-disable-next-line
const props = defineProps({
  title: String
})
const { title } = toRefs(props)

const { configForm, updateConfigForm } = inject('configForm')
const landingPages = computed(() => configForm.value.landingPages)

const { tableData, currentModifyTableRow, initPagesTable } = useTable(configForm, updateConfigForm)
const { showGlobalProfileModify, onProfileSelect, onProfileModifyConfirm } = useProfile(configForm, updateConfigForm)
const { showGlobalPagesModify, onLandingPageSelect, onPageModifyConfirm } = useLandingPages(configForm, updateConfigForm)

// 选择模板时，重新更新表格
eventBus.$on('gdtTemplateSelect', () => {
  nextTick(() => {
    initPagesTable(configForm.value.accounts)
  })
})
// 选择账号时，重新更新表格
eventBus.$on('gdtTemplateAccountChange', (accounts) => {
  nextTick(() => {
    initPagesTable(accounts)
  })
})
// 平台变化时，重新更新表格
eventBus.$on('gdtTemplatePlatformChange', () => {
  nextTick(() => {
    initPagesTable(configForm.value.accounts)
  })
})

// 应用id变化时，重新更新表格
eventBus.$on('gdtTemplatePromotedObjectChange', () => {
  nextTick(() => {
    initPagesTable(configForm.value.accounts)
  })
})

// 创意信息的首评回复变化时，重新更新表格
eventBus.$on('gdtTemplateCreativeComponentSocialSkillChange', () => {
  nextTick(() => {
    initPagesTable(configForm.value.accounts)
  })
})

// 创意信息选择小游戏试玩时，重新更新表格
eventBus.$on('gdtTemplateCreativeComponentWxgamePlayableChange', () => {
  nextTick(() => {
    initPagesTable(configForm.value.accounts)
  })
})

function onModifyModalCancel() {
  showGlobalProfileModify.value = false
  showGlobalPagesModify.value = false
}
</script>

<style lang="scss" scoped>
.creative-landingpage {
  .landing-page-wrapper {
    padding: 10px;
    height: 292px;
    overflow: auto;
  }
}
</style>
